import { isOneOfTags, isElementNode } from 'anodum';
import constraints from '../../constraints';

const isContentEditableAncestor = (element) => {
  if (!isElementNode(element)) return false;

  const ROOT_SELECTORS = constraints.accessors.getContentEditableRootSelector();
  return isOneOfTags(element, ROOT_SELECTORS) && element.hasAttribute('contenteditable');
};

export default isContentEditableAncestor;
